import { render, staticRenderFns } from "./PatientResult.vue?vue&type=template&id=0dde15be&scoped=true&"
import script from "./PatientResult.vue?vue&type=script&lang=js&"
export * from "./PatientResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde15be",
  null
  
)

export default component.exports